@if (responsiveService.isMobile()) {
  <div data-cy="assist-scheduler-mobile" class="overflow-x-hidder">
    <div class="reservationsCont" #view>
      <div class="heading-wrapper">
        <h2>
          {{ translation.dashboard.myReservations | transloco }}
        </h2>
        <p class="more-link padding-mobile">
          <a
            [routerLink]="['/reservations/all']"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: false }"
          >
            {{ translation.reservations.all | transloco }}
            <cue-icon class="arrow arrow-right" [icon]="ICONS.cueCaretRightFill" />
          </a>
        </p>
      </div>
      <div class="scroll-wrapperr" #parentSkeletonn>
        <table class="reservationsTable">
          @if (loading()) {
            <tr>
              <td class="dateTime"></td>
              <td colspan="2"></td>
            </tr>
          }
          @if (loading()) {
            <td colspan="3">
              <cue-loading data-cy="assist-scheduler-loading" style="padding-top: 20px; padding-bottom: 20px" />
            </td>
          }

          @if (!loading() && events().length === 0) {
            <tr>
              <td colspan="3" style="text-align: center">
                <div
                  data-cy="assist-scheduler-empty-state"
                  style="margin-top: 60px; margin-bottom: 60px"
                  class="flex flex-col items-center"
                >
                  <img src="assets/images/empty.png" width="81" height="60" />
                  <span style="display: block">{{ translation.dashboard.noEvents | transloco }}</span>
                </div>
              </td>
            </tr>
          }
          @if (!loading() && events().length > 0) {
            @for (event of events(); track event) {
              <assist-reservation-card
                [event]="event"
                (cancelParticipation)="cancelParticipation.emit($event)"
                (change)="change.emit($event)"
                (confirm)="confirm.emit($event)"
                (navigate)="navigate.emit($event)"
                (delete)="delete.emit($event)"
                (deleteSeries)="deleteSeries.emit($event)"
                (detail)="detail.emit($event)"
                (finish)="finish.emit($event)"
                (show)="show.emit($event)"
                [isColleague]="isColleague()"
                [class.confirmation-required]="event.showConfirmButton"
              />
            }
          }
        </table>
      </div>
    </div>
  </div>
}

@if (!responsiveService.isMobile()) {
  <div data-cy="assist-scheduler" class="heading-wrapper">
    <h2>
      {{ translation.common.reservations | transloco }}
    </h2>

    @if (!isColleague()) {
      <p class="more-link">
        <a [routerLink]="['/reservations/all']" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: false }">
          {{ translation.reservations.all | transloco }}
          <cue-icon class="arrow arrow-right" [icon]="ICONS.cueCaretRightFill" />
        </a>
      </p>
    }
  </div>

  @if (loading()) {
    <cue-loading data-cy="assist-scheduler-loading" style="padding-top: 20px; padding-bottom: 20px" />
  }

  @if (!loading() && events().length > 0) {
    @for (event of events(); track event.id) {
      <assist-reservation-card
        [event]="event"
        (cancelParticipation)="cancelParticipation.emit($event)"
        (change)="change.emit($event)"
        (confirm)="confirm.emit($event)"
        (delete)="delete.emit($event)"
        (deleteSeries)="deleteSeries.emit($event)"
        (detail)="detail.emit($event)"
        (finish)="finish.emit($event)"
        (navigate)="navigate.emit($event)"
        (show)="show.emit($event)"
        [isColleague]="isColleague()"
        [class.confirmation-required]="event.showConfirmButton"
      />
    }
  }

  @if (!loading() && events().length === 0) {
    <div
      data-cy="assist-scheduler-empty-state"
      class="flex flex-col items-center"
      style="margin: 0 auto; text-align: center; width: 100%"
    >
      <img src="assets/images/empty.png" width="81" height="60" />
      <span style="display: block">{{ translation.dashboard.noEvents | transloco }}</span>
    </div>
  }
}
